import { Selector } from '@ngxs/store';
import { AppState, AppStateModel } from './app.state';

export class AppSelectors {
   @Selector([AppState])
   public static isVisible(state: AppStateModel): boolean {
      return state.isVisible;
   }
}
